export function tabbedSliderNav() {
    const tabbedSliderWrap = $('.tabbed-slider-nav-holder');
    tabbedSliderWrap.each(function () {
        const tabbedSliderNav = $(this).find('.tabbed-slider-nav');
        const prevArrow = $(this).find('.prev-arrow');
        const nextArrow = $(this).find('.next-arrow');
        let sliderSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            focusOnSelect: true,
            mobileFirst: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 4,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 1799,
                    settings: {
                        slidesToShow: 5,
                        variableWidth: false
                    }
                }
            ]
        }

        tabbedSliderNav.slick(sliderSettings);

        if (prevArrow.hasClass("slick-hidden")) {
            tabbedSliderNav.addClass("arrows-hidden");
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabbedSliderNav.js